import { Button } from "@chakra-ui/react";

export const BlueButton = ({
  label,
  onClick,
  isDisabled = false,
}: {
  label: String;
  onClick: () => void;
  isDisabled?: boolean;
}) => (
  <Button
    colorScheme="blue"
    borderRadius="full"
    px={4}
    w="full"
    minW={150}
    fontWeight="medium"
    fontSize="sm"
    onClick={onClick}
    disabled={isDisabled}
  >
    {label}
  </Button>
);

export const WhiteOutlineButton = ({
  label,
  onClick,
}: {
  label: String;
  onClick: () => void;
}) => (
  <Button
    variant="outline"
    borderColor="white"
    textFillColor={"white"}
    borderRadius="full"
    px={4}
    w="full"
    minW={150}
    fontWeight="medium"
    fontSize="sm"
    onClick={onClick}
  >
    {label}
  </Button>
);
